import { Button, Result } from "antd";
import { useBailiffConvert } from "hook/bailiff/document/action/useBailiffConvert";
// import { useBailiffUpload } from "hook/bailiff/document/action/useBailiffUpload";
import {
  FLOWS,
  useLoadingFinishFlow,
} from "hook/bailiff/document/flow/useLoadingFinishFlow";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
const FinishCompleted = () => {
  // -------------------------- VAR -----------------------------
  const { flow } = useLoadingFinishFlow();
  const { turnBack } = useBailiffConvert();
  const isFlow = flow === FLOWS.FINISH;

  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  if (!isFlow) return null;
  return (
    <div className="flex min-h-[200px] items-center justify-center">
      <Result
        status={"success"}
        title="File của bạn đăng tải thành công"
        subTitle="Hệ thống AI sẽ tiến hành phân tích toàn diện và gửi báo giá chính xác đến Quý khách trong vòng 10 phút. Kết quả sẽ được hiển thị trên màn hình sau khi phân tích và đánh giá."
        extra={
          <Button onClick={turnBack} className="min-h-[40px]" type="primary">
            Tải lên file khác
          </Button>
        }
      />
    </div>
  );
};
export default FinishCompleted;
